/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//@flow

import React from 'react';
import { ChoiceList, InlineError } from '@shopify/polaris';

export const RenderChoice = (field: Object) => {
  return (
    <div>
      <ChoiceList
        id={field.input.name}
        choices={field.choices ? field.choices : ''}
        title={field.label ? field.label : ''}
        selected={field.input.value}
        onChange={field.input.onChange}
        disabled={field.isDisabled ? true : false}
        {...field.anotherProps}
      />
      {field.meta.error ? <InlineError message={field.meta.error} /> : ''}
    </div>
  );
};
